export const settingKeys = {
  currentBookId: "currentBookId",
  currentChapterId: "currentChapterId",
  currentChapterPlayedTime: "currentChapterPlayedTime",
  playedTime: "playedTime",
  defaultChapterSort: "defaultChapterSort",
};

// Các tag chỉ mang tính nguồn/kênh phát (đài), không phản ánh thể loại nội dung
// -> loại khỏi danh sách tag dùng để tìm audio liên quan
export const excludedRelatedTagNames = ["voh", "vov"];